export default __webpack_public_path__ + "static/Image044_small-0294d101c7d5c994f36a3464070a84a3.png";